import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ContactAddress from './ContactAddress';

function ContactForm() {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);

  const getClientInfo = async () => {
    let ip = 'Unavailable';

    try {
      const res = await fetch('https://api.ipify.org?format=json');
      const data = await res.json();
      ip = data.ip;
    } catch (e) {
      console.warn('IP fetch failed');
    }

    return {
      ip,
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      language: navigator.language,
      screen: `${window.screen.width}x${window.screen.height}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;
    // Basic validation check before sending (optional but good practice)
    if (!form.name.value || !phone || !form.message.value) {
      toast.error('Veuillez remplir tous les champs obligatoires.');
      setLoading(false);
      return;
    }

    const clientInfo = await getClientInfo();

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      {
        from_name: form.name.value,
        phone: phone,
        message: form.message.value,

        ip_address: clientInfo.ip,
        user_agent: clientInfo.userAgent,
        platform: clientInfo.platform,
        language: clientInfo.language,
        screen: clientInfo.screen,
        timezone: clientInfo.timezone,
      },
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
      .then(() => {
        toast.success('Message envoyé avec succès');
        form.reset();
        setPhone('');
      })
      .catch((err) => {
        console.error(err);
        toast.error('Erreur lors de l’envoi');
      })
      .finally(() => setLoading(false));
  };

  return (
    <section className="contact-area pt-110 pb-110">
      <div className="container">
        <div className="container-inner-wrap">
          <div className="row justify-content-center justify-content-lg-between">
            <div className="col-lg-6 col-md-8">
              <div className="contact-title mb-20">
                <h5 className="sub-title">Contactez-nous</h5>
                <h2 className="title">Parlons de votre question<span>.</span></h2>
              </div>

              <div className="contact-wrap-content">
                <p>N'hésitez pas à nous contacter pour toute question.</p>

                <form className="contact-form" onSubmit={sendEmail}>
                  <div className="form-grp">
                    <label>Votre Nom <span>*</span></label>
                    <input type="text" name="name" placeholder="Flen Fouleni" required />
                  </div>

                  <div className="form-grp">
                    <label>Votre Numéro <span>*</span></label>
                    <input
                      type="text"
                      value={phone}
                      onChange={(e) => /^\d*$/.test(e.target.value) && setPhone(e.target.value)}
                      placeholder="eg: 98 765 432"
                      required
                    />
                  </div>

                  <div className="form-grp">
                    <label>Votre Message <span>*</span></label>
                    <textarea name="message" placeholder="Votre Message" required />
                  </div>

                  <button className="btn rounded-btn" disabled={loading}>
                    {loading ? 'Envoi...' : 'Envoyer Maintenant'}
                  </button>
                </form>
              </div>
            </div>

            <ContactAddress />
          </div>
        </div>
      </div>
      <ToastContainer position="bottom-right" />
    </section>
  );
}

export default ContactForm;
